import { put, call, takeEvery } from 'redux-saga/effects';
import { CREATE_FONT_REQUEST, AVAILABLE_FONTS_REQUEST } from './actionTypes';
import {
  createFontSuccess,
  createFontFailure,
  availableFontsSuccess,
  availableFontsFailure,
} from './actions';
import FontService from '../../services/FontService';

export function* getAvailableFontsTask() {
  try {
    const availableFonts = yield call(FontService.getAvailableFonts);
    yield put(availableFontsSuccess(availableFonts));
  } catch (error) {
    yield put(availableFontsFailure(error));
  }
}

export function* createFontTask(action) {
  const params = action.payload;

  try {
    const font = yield call(FontService.createFont, params.file);
    params.onSuccess();
    yield put(createFontSuccess(font));
  } catch (error) {
    params.onError();
    yield put(createFontFailure(error));
  }
}

export function* fontsSaga() {
  yield takeEvery(AVAILABLE_FONTS_REQUEST, getAvailableFontsTask);
  yield takeEvery(CREATE_FONT_REQUEST, createFontTask);
}
